import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    favoritesCount: 0,
    sidebarObjects: [],
  },
  reducers: {
    setFavoritesCount: (state, action) => {
      state.favoritesCount = action.payload;
    },
    setSidebarObjects: (state, action) => {
      state.sidebarObjects = action.payload;
    }
  },
});
export const { setFavoritesCount, setSidebarObjects } = sidebarSlice.actions;

export default sidebarSlice.reducer;
